const config = {
    siteName: 'Binh Minh ERP Phase 1',
    tagLine: 'Binh Minh ERP Phase 1'
};

export const SHIPPING_LEVELS = [
    { value: '50', name: 'First class' },
    { value: '60', name: 'Priority' },
]

export const CARRIERS_SUPPORT_SHIPPING_LEVELS = ['flashship_usps']

export const SHIPPING_PLANS = [
    { value: 'standard', name: 'Standard' },
    { value: 'fast', name: 'Priority' },
]

export default config;